import { render, staticRenderFns } from "./UserHistory.vue?vue&type=template&id=39fb6904&"
import script from "./UserHistory.vue?vue&type=script&lang=ts&"
export * from "./UserHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports